import React, { useEffect, useState } from 'react';

// Thin reading-progress bar pinned to the very top of the viewport.
export function ScrollProgressBar({ color = '#0056D2' }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollTop = doc.scrollTop || document.body.scrollTop;
      const scrollHeight = (doc.scrollHeight || document.body.scrollHeight) - doc.clientHeight;
      setProgress(scrollHeight > 0 ? Math.min(100, (scrollTop / scrollHeight) * 100) : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 h-[3px] z-50 bg-transparent pointer-events-none">
      <div
        className="h-full"
        style={{
          width: `${progress}%`,
          background: `linear-gradient(90deg, ${color}, ${color}99)`,
          transition: 'width 0.1s linear',
        }}
      />
    </div>
  );
}
